import { render, staticRenderFns } from "./FeaturedArticles.vue?vue&type=template&id=4cd19588"
import script from "./FeaturedArticles.vue?vue&type=script&lang=js"
export * from "./FeaturedArticles.vue?vue&type=script&lang=js"
import style0 from "./FeaturedArticles.vue?vue&type=style&index=0&id=4cd19588&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports